import $ from 'jquery'
import 'js-cookie';

class SiteTerms {
    constructor() {
        this.termsBtn = $('#terms-accept');
        this.termsPopup = $('.terms-popup');
        this.cookieVal = $('#terms-accept').attr('data-cookie-date') + $('#terms-accept').attr('data-cookie-version');
        this.events();
    }

    // Events
    events() {
        this.termsBtn.on('click', this.termsHandler.bind(this))
    }

    termsHandler() {
        Cookies.set('agreed_to_the_rules', this.cookieVal, {expires: 365, path: '/'});
        this.termsPopup.addClass('slideOutDown');
    }
}

export default SiteTerms;
